// tslint:disable: max-line-length
import React from "react"

export default function Planning() {
  return (
    <symbol id="svg-planning" viewBox="0 0 36 36">
      <path
        d="M31.5 25.5V12H10.5V25.5H31.5ZM31.5 4.5C32.2957 4.5 33.0587 4.81607 33.6213 5.37868C34.1839 5.94129 34.5 6.70435 34.5 7.5V25.5C34.5 26.2957 34.1839 27.0587 33.6213 27.6213C33.0587 28.1839 32.2957 28.5 31.5 28.5H10.5C8.835 28.5 7.5 27.15 7.5 25.5V7.5C7.5 6.70435 7.81607 5.94129 8.37868 5.37868C8.94129 4.81607 9.70435 4.5 10.5 4.5H12V1.5H15V4.5H27V1.5H30V4.5H31.5ZM4.5 31.5H25.5V34.5H4.5C2.835 34.5 1.5 33.15 1.5 31.5V13.5H4.5V31.5Z"
        fill="currentColor"
      />
    </symbol>
  )
}
